import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';
import global from '../../../common/utility/global';

import CustomTable from '../../../components/CustomTable';
import { REGISTRADO, EN_PROCESO, CERRADO, ANULADO } from '../../../common/types/fondoFijoEstadoType';


export default function ResultList(props) {
    const renderColor = (row) => {
        if (row.idFondoFijoEstado === REGISTRADO)
            return 'blue';
        if (row.idFondoFijoEstado === EN_PROCESO)
            return 'yellow';
        if (row.idFondoFijoEstado === CERRADO)
            return 'verde';
        if (row.idFondoFijoEstado === ANULADO)
            return 'red';
    };

    return (
        <CustomTable
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">

                            <Tooltip placement="top" title="Ver">
                                <Button
                                    type="primary"
                                    icon="search"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onVer(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Editar">
                                <Button
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onEdit(row)}
                                    disabled={row.idFondoFijoEstado !== REGISTRADO ? true : false}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Detalle">
                                <Button
                                    type="primary"
                                    icon="plus"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onDetail(row)}
                                    disabled={row.idFondoFijoEstado !== REGISTRADO ? true : false}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Anular">
                                <Button
                                    type="danger"
                                    icon="delete"
                                    size={"small"}
                                    onClick={() => props.onAnular(row)}
                                    disabled={row.idFondoFijoEstado === REGISTRADO ? false : true}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Imprimir">
                                <Button
                                    type="primary"
                                    icon="printer"
                                    size={"small"}
                                // onClick={() => props.onImprimir(row)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Serie - Documento',
                    dataIndex: 'serieDocumento',
                    key: 'serieDocumento',
                    sorter: true
                },
                {
                    title: 'Establecimiento',
                    dataIndex: 'nombreEstablecimiento',
                    key: 'nombreEstablecimiento',
                    sorter: true
                },
                {
                    title: 'Centro de Costo',
                    dataIndex: 'nombreCentroCosto',
                    key: 'nombrecentroCosto',
                    sorter: true
                },
                {
                    title: 'Responsable',
                    dataIndex: 'responsable',
                    key: 'responsable',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },
                {
                    title: 'Fecha',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },
                {
                    title: 'Saldo Inicial Soles',
                    dataIndex: 'saldoInicialSoles',
                    key: 'saldoInicialSoles',
                    align: 'right',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Saldo Cierre Soles',
                    dataIndex: 'saldoCierreSoles',
                    key: 'saldoCierreSoles',
                    align: 'right',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Saldo Inicial Dolares',
                    dataIndex: 'saldoInicialDolares',
                    key: 'saldoInicialDolares',
                    align: 'right',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Saldo Cierre Dolares',
                    dataIndex: 'saldoCierreDolares',
                    key: 'saldoCierreDolares',
                    align: 'right',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Tipo Cambio',
                    dataIndex: 'tipoCambio',
                    key: 'tipoCambio',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Estado',
                    dataIndex: 'nombreFondoFijoEstado',
                    key: 'nombreFondoFijoEstado',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    )
}